import React, { createContext, useState, useContext } from 'react';

const SUPERGROW2_STORAGE_KEY = 'supergrow2_enabled';

const Supergrow2Context = createContext();

// Utility function to clear Supergrow 2.0 storage (used on logout)
export const clearSupergrow2Storage = () => {
  localStorage.removeItem(SUPERGROW2_STORAGE_KEY);
};

export const Supergrow2Provider = ({ children }) => {
  const [isSupergrow2Enabled, setIsSupergrow2Enabled] = useState(() => {
    // Initialize from localStorage
    const stored = localStorage.getItem(SUPERGROW2_STORAGE_KEY);
    return stored === 'true';
  });

  const setSupergrow2 = (enabled) => {
    setIsSupergrow2Enabled(enabled);
    // Persist to localStorage
    localStorage.setItem(SUPERGROW2_STORAGE_KEY, String(enabled));
  };

  return (
    <Supergrow2Context.Provider
      value={{
        isSupergrow2Enabled,
        setSupergrow2
      }}
    >
      {children}
    </Supergrow2Context.Provider>
  );
};

export const useSupergrow2 = () => {
  const context = useContext(Supergrow2Context);
  if (!context) {
    throw new Error('useSupergrow2 must be used within a Supergrow2Provider');
  }
  return context;
};

export { Supergrow2Context };
